import { CLEAR_LINKS, GET_LINKS } from 'modules/bookLinks/store/constants';

export const clearLinks = () => ({
  type: CLEAR_LINKS,
});

export const getLinks = () => ({
  type: GET_LINKS,
});
